module.exports = __webpack_public_path__ + "media/images/desktop/edit-pen-672d215de7e9b4e9040449b88385980f.svg";